import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql, compose } from "react-apollo";
import {
  mutationDeleteTemplateList,
  mutationDeleteTemplateReply
} from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import ConfirmModal from "module-common/ConfirmModal";

export default compose(
  graphql(mutationDeleteTemplateList, {
    name: "mutationDeleteList"
  }),
  graphql(mutationDeleteTemplateReply, {
    name: "mutationDeleteReply"
  })
)(
  class DeleteButton extends Component {
    static propTypes = {
      id: PropTypes.number,
      isDeleteList: PropTypes.bool
    };

    state = { showModal: false };

    render() {
      const { isDeleteList } = this.props;
      return [
        <Icon
          key="trash"
          name="recycle-bin"
          onClick={() => this.setState({ showModal: true })}
        />,
        this.state.showModal && (
          <ConfirmModal
            key="modal"
            text={
              isDeleteList
                ? "Do you want to delete this template list?"
                : "Do you want to delete this template reply?"
            }
            onCancel={() => this.setState({ showModal: false })}
            onConfirm={this.onConfirm}
          />
        )
      ];
    }

    onConfirm = async () => {
      const {
        id,
        isDeleteList,
        mutationDeleteList,
        mutationDeleteReply
      } = this.props;
      try {
        if (isDeleteList) {
          await mutationDeleteList({
            variables: {
              id: id
            },
            refetchQueries: ["getTemplateList"]
          });
        } else {
          await mutationDeleteReply({
            variables: {
              id: id
            },
            refetchQueries: ["getTemplateList"]
          });
        }

        ShowNotice("template-reply-delete-success");
      } catch (error) {
        ShowNotice("template-reply-delete-error");
      }
      this.setState({ showModal: false });
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/template-reply/DeleteButtonWithMutation.js